import useAuth from '../../hooks/useAuth';
import CreateAccountPage from '../create-account/CreateAccountPage';
import AcceptInvitationPage from '../accept-invitation/AcceptInvitationPage';
import CreateOrganizationPage from '../create-organization/CreateOrganizationPage';
import CreatePropertyPage from '../create-property/CreatePropertyPage';
import { Navigate } from 'react-router-dom';
import {
  USER_INVITATION_STATUS,
  USER_STATUS,
  UserInvitation,
} from 'vendor-marketplace-shared-library';
import React from 'react';
import { Box, useTheme } from '@mui/material';

export default function OnboardingPage() {
  const { accessToken, userQuery, forcePropertyPageOnboarding } = useAuth();
  const theme = useTheme();

  const hasActiveStatus = userQuery.data?.me.status === USER_STATUS.ACTIVE;
  const hasActiveInvitations = userQuery.data?.me?.phoneContactMethod?.userInvitations?.some(
    (invitation: UserInvitation) =>
      [USER_INVITATION_STATUS.CREATED, USER_INVITATION_STATUS.SENT].includes(
        invitation.inviteStatus!,
      ),
  );
  const hasCreatedOrganizationAccount = userQuery.data?.me.organizationAccount;
  const hasCreatedProperties = userQuery.data?.me.properties?.length;

  if (accessToken) {
    if (!hasActiveStatus) {
      return (
        <Box sx={{ backgroundColor: theme.palette.secondary.light }}>
          <CreateAccountPage />
        </Box>
      );
    } else if (hasActiveInvitations && !hasCreatedOrganizationAccount) {
      return (
        <Box sx={{ backgroundColor: theme.palette.secondary.light }}>
          <AcceptInvitationPage />
        </Box>
      );
    } else if (!hasCreatedOrganizationAccount) {
      return (
        <Box sx={{ backgroundColor: theme.palette.secondary.light }}>
          <CreateOrganizationPage />
        </Box>
      );
    } else if (!hasCreatedProperties || forcePropertyPageOnboarding) {
      return (
        <Box sx={{ backgroundColor: theme.palette.secondary.light }}>
          <CreatePropertyPage />
        </Box>
      );
    } else {
      return <Navigate to='/' />;
    }
  } else {
    return <Navigate to='/login' />;
  }
}
